// extracted by mini-css-extract-plugin
export var numpadContainer = "_pv-1";
export var phoneButton = "_pv-0";